import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {AlertController, IonicModule} from '@ionic/angular';

import {QsChecksPage} from './qs-checks.page';
import {TranslateModule} from '@ngx-translate/core';
import {EffectsModule} from '@ngrx/effects';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {StoreModule} from '@ngrx/store';
import {reducers} from './qs-checks.reducer';
import {EffectsWs} from './qs-checks.effects.ws';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';
import {
    QschecksFunktionsbereichePruefplaeneAdminEffects,
    QschecksPruefAntwortAktualisierenEffects, QschecksPruefaufgabeAktualisierenEffects, QschecksPruefaufgabeEntfernenEffects, QschecksPruefaufgabeHinzufuegenEffects, QschecksPruefaufgabeKopierenEffects, QschecksPruefaufgabeReihenfolgeSetzenEffects, QschecksPruefchecklisteAktualisierenEffects, QschecksPruefchecklisteEntfernenEffects, QschecksPruefchecklisteHinzufuegenEffects, QschecksPruefchecklisteKopierenEffects, QschecksPruefchecklisteReihenfolgeSetzenEffects,
    QschecksPruefobjektAktualisierenEffects, QschecksPruefobjektEntfernenEffects,
    QschecksPruefobjektHinzufuegenEffects, QschecksPruefobjektKopierenEffects,
    QschecksPruefplanAdminEffects,
    QschecksPruefplanAktualisierenEffects,
    QschecksPruefplanAntwortAdminEffects,
    QschecksPruefplanAntwortenAdminEffects, QschecksPruefplanEntfernenEffects,
    QschecksPruefplanHinzufuegenEffects, QschecksPruefplanKopierenEffects, QschecksPruefplanPruefaufgabeAdminEffects, QschecksPruefplanPruefaufgabenAdminEffects, QschecksPruefplanPruefchecklisteAdminEffects,
    QschecksPruefplanPruefchecklistenAdminEffects,
    QschecksPruefplanPruefobjektAdminEffects,
    QschecksPruefplanPruefobjekteAdminEffects, QschecksPruefplanRolleControllerEntfernenEffects, QschecksPruefplanRollenControllerAdminEffects, QschecksPruefplanRollenControllerHinzufuegenEffects, QschecksPruefplanRollenPrueferAdminEffects, QschecksPruefplanRollenPrueferEntfernenEffects, QschecksPruefplanRollenPrueferHinzufuegenEffects
} from '../../../client-ngrx/qschecks';
import {QsChecksUiEffects} from './qs-checks.effects.ui';

const routes: Routes = [
    {
        path: '',
        component: QsChecksPage,
        data: {title: 'QS Checks verwalten'}
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule,
        StoreModule.forFeature('QsChecksPage', reducers),
        EffectsModule.forFeature([
            QsChecksUiEffects,
            EffectsWs,

            // Prüfpläne
            QschecksFunktionsbereichePruefplaeneAdminEffects,
            QschecksPruefplanAdminEffects,
            QschecksPruefplanHinzufuegenEffects,
            QschecksPruefplanEntfernenEffects,
            QschecksPruefplanKopierenEffects,
            QschecksPruefplanAktualisierenEffects,
            QschecksPruefplanAntwortenAdminEffects,
            QschecksPruefplanAntwortAdminEffects,
            QschecksPruefAntwortAktualisierenEffects,

            // Prüfobjekte
            QschecksPruefplanPruefobjekteAdminEffects,
            QschecksPruefplanPruefobjektAdminEffects,
            QschecksPruefobjektAktualisierenEffects,
            QschecksPruefobjektHinzufuegenEffects,
            QschecksPruefobjektKopierenEffects,
            QschecksPruefobjektEntfernenEffects,

            // Prüf-Checklisten
            QschecksPruefplanPruefchecklistenAdminEffects,
            QschecksPruefplanPruefchecklisteAdminEffects,
            QschecksPruefchecklisteAktualisierenEffects,
            QschecksPruefchecklisteEntfernenEffects,
            QschecksPruefchecklisteHinzufuegenEffects,
            QschecksPruefchecklisteKopierenEffects,
            QschecksPruefchecklisteReihenfolgeSetzenEffects,

            // Prüf-Aufgaben
            QschecksPruefplanPruefaufgabenAdminEffects,
            QschecksPruefplanPruefaufgabeAdminEffects,
            QschecksPruefaufgabeAktualisierenEffects,
            QschecksPruefaufgabeEntfernenEffects,
            QschecksPruefaufgabeHinzufuegenEffects,
            QschecksPruefaufgabeKopierenEffects,
            QschecksPruefaufgabeReihenfolgeSetzenEffects,

            // Berechtigungen
            QschecksPruefplanRollenPrueferAdminEffects,
            QschecksPruefplanRollenPrueferEntfernenEffects,
            QschecksPruefplanRollenPrueferHinzufuegenEffects,
            QschecksPruefplanRolleControllerEntfernenEffects,
            QschecksPruefplanRollenControllerAdminEffects,
            QschecksPruefplanRollenControllerHinzufuegenEffects
        ]),
        SopiScrollModule,
        DragDropModule,
        SopiComponentsModule.forRoot()
    ],
    declarations: [QsChecksPage],
    entryComponents: [QsChecksPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class QsChecksPageModule {
}
